module.exports = "/cyber/_next/static/images/genshinTooltip-8fe107542d8708228d443f6a78afd3a3.jpg";